var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('tabs',{staticClass:"border-bottom",attrs:{"tabs":_vm.rutas}}),_c('div',{staticClass:"custom-scroll overflow-auto",staticStyle:{"height":"calc(100vh - 122px)"}},[_c('router-view',{key:_vm.$route.name})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }